import React, { useState, useCallback, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaTimes, FaChevronLeft, FaChevronRight, FaExpand, FaFacebookF, FaInstagram } from 'react-icons/fa';
import './ConstructionGallery.css';

const galleryItems = [
  {
    id: 1,
    src: '/images/constructions/480698706_672380351788131_644284137246221768_n_edit_733408924754441.jpg',
    title: 'Modern Villa Exterior',
    category: 'residential',
    size: 'large',
  },
  {
    id: 2,
    src: '/images/constructions/FB_IMG_1775186505275_edit_822376531407638.jpg',
    title: 'Custom Room Divider',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 3,
    src: '/images/constructions/481025388_671270085232491_7515111281435762230_n_edit_733435905348128.jpg',
    title: 'Handcrafted Wooden Door',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 4,
    src: '/images/constructions/FB_IMG_1775186490876.jpg',
    title: 'Roofing & Structure Work',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 5,
    src: '/images/constructions/FB_IMG_1775186530466.jpg',
    title: 'Salon Interior Fitout',
    category: 'commercial',
    size: 'large',
  },
  {
    id: 6,
    src: '/images/constructions/FB_IMG_1775186512398.jpg',
    title: 'Window Frame Crafting',
    category: 'woodwork',
    size: 'small',
  },
  {
    id: 7,
    src: '/images/constructions/FB_IMG_1775186489179.jpg',
    title: 'Residential Front Entrance',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 8,
    src: '/images/constructions/FB_IMG_1775186550854.jpg',
    title: 'Kitchen Cabinetry & Countertops',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 9,
    src: '/images/constructions/FB_IMG_1775186604150.jpg',
    title: 'Custom Wooden Gate',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 10,
    src: '/images/constructions/481052230_671269195232580_5709001031448433430_n_edit_733537526066735.jpg',
    title: 'Luxury Interior Doors',
    category: 'woodwork',
    size: 'large',
  },
  {
    id: 11,
    src: '/images/constructions/FB_IMG_1775186497370.jpg',
    title: 'Interior Woodwork & Finishing',
    category: 'interior',
    size: 'small',
  },
  {
    id: 12,
    src: '/images/constructions/FB_IMG_1775186545082.jpg',
    title: 'Two-Story Build',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 13,
    src: '/images/constructions/FB_IMG_1775186521439.jpg',
    title: 'Custom Vanity Cabinet',
    category: 'woodwork',
    size: 'small',
  },
  {
    id: 14,
    src: '/images/constructions/FB_IMG_1775186559631_edit_822453964169692.jpg',
    title: 'Premium Entrance Door',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 15,
    src: '/images/constructions/FB_IMG_1775186493336.jpg',
    title: 'Modern Villa Construction',
    category: 'residential',
    size: 'large',
  },
  {
    id: 16,
    src: '/images/constructions/FB_IMG_1775186500288.jpg',
    title: 'Balcony & Railing Work',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 17,
    src: '/images/constructions/FB_IMG_1775186507565_edit_822397868958984.jpg',
    title: 'Custom Ceiling Design',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 18,
    src: '/images/constructions/FB_IMG_1775186509551_edit_822414863692206.jpg',
    title: 'Living Room Interior',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 19,
    src: '/images/constructions/FB_IMG_1775186514087.jpg',
    title: 'Full House Construction',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 20,
    src: '/images/constructions/FB_IMG_1775186515885.jpg',
    title: 'Modern Kitchen Setup',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 21,
    src: '/images/constructions/FB_IMG_1775186518105.jpg',
    title: 'Wooden Staircase',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 22,
    src: '/images/constructions/FB_IMG_1775186523890.jpg',
    title: 'Exterior Finishing',
    category: 'residential',
    size: 'small',
  },
  {
    id: 23,
    src: '/images/constructions/FB_IMG_1775186526224.jpg',
    title: 'Commercial Space Build',
    category: 'commercial',
    size: 'medium',
  },
  {
    id: 24,
    src: '/images/constructions/FB_IMG_1775186528187.jpg',
    title: 'Pantry Cupboards',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 25,
    src: '/images/constructions/481056298_671270025232497_4559655183476913658_n_edit_733457099830777.jpg',
    title: 'Wooden Door Installation',
    category: 'woodwork',
    size: 'large',
  },
  {
    id: 26,
    src: '/images/constructions/FB_IMG_1775186502405.jpg',
    title: 'Residential Build',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 27,
    src: '/images/constructions/FB_IMG_1775186532386.jpg',
    title: 'Interior Fitout',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 28,
    src: '/images/constructions/FB_IMG_1775186534246.jpg',
    title: 'Construction Work',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 29,
    src: '/images/constructions/FB_IMG_1775186536115.jpg',
    title: 'Woodwork Project',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 30,
    src: '/images/constructions/FB_IMG_1775186557083.jpg',
    title: 'Interior Design Work',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 31,
    src: '/images/constructions/FB_IMG_1775186561917_edit_822479178809109.jpg',
    title: 'Custom Build',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 32,
    src: '/images/constructions/FB_IMG_1775186563904_edit_822519509497167.jpg',
    title: 'Premium Woodwork',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 33,
    src: '/images/constructions/FB_IMG_1775186566021_edit_822825639286529.jpg',
    title: 'Interior Finishing',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 34,
    src: '/images/constructions/FB_IMG_1775186569511_edit_822835663218140.jpg',
    title: 'Renovation Project',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 35,
    src: '/images/constructions/FB_IMG_1775186573336.jpg',
    title: 'Construction Site',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 36,
    src: '/images/constructions/FB_IMG_1775186576225_edit_823183357889830.jpg',
    title: 'Custom Carpentry',
    category: 'woodwork',
    size: 'medium',
  },
  {
    id: 37,
    src: '/images/constructions/FB_IMG_1775186587569_edit_823215730107266.jpg',
    title: 'Interior Space',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 38,
    src: '/images/constructions/FB_IMG_1775186606008.jpg',
    title: 'Residential Project',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 39,
    src: '/images/constructions/FB_IMG_1775186607937.jpg',
    title: 'Woodwork Detail',
    category: 'woodwork',
    size: 'small',
  },
  {
    id: 40,
    src: '/images/constructions/FB_IMG_1775186611546.jpg',
    title: 'Build Progress',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 41,
    src: '/images/constructions/FB_IMG_1775186613586.jpg',
    title: 'Interior Work',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 42,
    src: '/images/constructions/FB_IMG_1775186615475.jpg',
    title: 'Commercial Fitout',
    category: 'commercial',
    size: 'medium',
  },
  {
    id: 43,
    src: '/images/constructions/FB_IMG_1775186616956.jpg',
    title: 'Structural Work',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 44,
    src: '/images/constructions/FB_IMG_1775186618533.jpg',
    title: 'Finishing Work',
    category: 'interior',
    size: 'medium',
  },
  {
    id: 45,
    src: '/images/constructions/IMG-20220602-WA0058.jpg',
    title: 'Construction Project 2022',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 46,
    src: '/images/constructions/IMG-20230505-WA0010.jpg',
    title: 'Build Work 2023',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 47,
    src: '/images/constructions/IMG-20240607-WA0006.jpg',
    title: 'Project 2024',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 48,
    src: '/images/constructions/IMG-20250512-WA0048.jpg',
    title: 'Renovation 2025',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 49,
    src: '/images/constructions/IMG-20250512-WA0053.jpg',
    title: 'Construction 2025',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 50,
    src: '/images/constructions/IMG_20181120_122437.jpg',
    title: 'Early Project 2018',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 51,
    src: '/images/constructions/IMG_20201009_092012.jpg',
    title: 'Build 2020',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 52,
    src: '/images/constructions/IMG_20210321_145716.jpg',
    title: 'Project 2021',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 53,
    src: '/images/constructions/IMG_20240414_125537.jpg',
    title: 'Site Work 2024',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 54,
    src: '/images/constructions/IMG_20240809_162306.jpg',
    title: 'Construction 2024',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 55,
    src: '/images/constructions/IMG_20260215_125300_1.jpg',
    title: 'Recent Build 2026',
    category: 'residential',
    size: 'large',
  },
  {
    id: 56,
    src: '/images/constructions/IMG_20260215_125456_1.jpg',
    title: 'Recent Project 2026',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 57,
    src: '/images/constructions/IMG_20260215_125600.jpg',
    title: 'Latest Work 2026',
    category: 'residential',
    size: 'medium',
  },
  {
    id: 58,
    src: '/images/constructions/IMG_20260401_140417.jpg',
    title: 'April 2026 Project',
    category: 'residential',
    size: 'large',
  },
  {
    id: 59,
    src: '/images/constructions/IMG_20260401_140454.jpg',
    title: 'April 2026 Build',
    category: 'residential',
    size: 'medium',
  },
];

const filters = [
  { key: 'all', label: 'All Recent Work' },
  { key: 'residential', label: 'Residential' },
  { key: 'woodwork', label: 'Woodwork' },
  { key: 'interior', label: 'Interior' },
  { key: 'commercial', label: 'Commercial' },
];

const ConstructionGallery = () => {
  const [ref, inView] = useInView({ threshold: 0.05, triggerOnce: true });
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });
  const [visibleCount, setVisibleCount] = useState(12);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const filtered = activeFilter === 'all'
    ? galleryItems
    : galleryItems.filter((item) => item.category === activeFilter);

  const visibleItems = activeFilter === 'all' ? filtered : filtered.slice(0, visibleCount);

  const openLightbox = useCallback((index) => {
    setLightbox({ open: true, index });
    document.body.style.overflow = 'hidden';
  }, []);

  const closeLightbox = useCallback(() => {
    setLightbox({ open: false, index: 0 });
    document.body.style.overflow = '';
  }, []);

  const navigateLightbox = useCallback((direction) => {
    setLightbox((prev) => {
      const newIndex = direction === 'next'
        ? (prev.index + 1) % filtered.length
        : (prev.index - 1 + filtered.length) % filtered.length;
      return { ...prev, index: newIndex };
    });
  }, [filtered.length]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') navigateLightbox('next');
    if (e.key === 'ArrowLeft') navigateLightbox('prev');
  }, [closeLightbox, navigateLightbox]);

  const handleTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchEnd = useCallback((e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = Math.abs(e.changedTouches[0].clientY - touchStartY.current);
    // Only swipe horizontally (not a vertical scroll)
    if (Math.abs(dx) > 50 && dy < 80) {
      if (dx < 0) navigateLightbox('next');
      else navigateLightbox('prev');
    }
    touchStartX.current = null;
    touchStartY.current = null;
  }, [navigateLightbox]);

  React.useEffect(() => {
    if (lightbox.open) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [lightbox.open, handleKeyDown]);

  const handleFilterChange = (key) => {
    setActiveFilter(key);
    setVisibleCount(12);
  };

  return (
    <section className="gallery" id="gallery" ref={ref}>
      <div className="gallery__bg-text">GALLERY</div>
      <div className="gallery__container">
        <motion.div
          className="gallery__header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className="section-tag">Recent Projects</span>
          <h2 className="section-title">
            A Glimpse of Our
            <br />
            <span className="text-green">Recent Work</span>
          </h2>
          <p className="section-description">
            Just a snapshot — out of 2,000+ completed projects, here are some of our
            recent construction, woodwork, and interior design highlights across Sri Lanka.
          </p>
        </motion.div>

        <motion.div
          className="gallery__filters"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {filters.map((f) => (
            <button
              key={f.key}
              className={`gallery__filter ${activeFilter === f.key ? 'gallery__filter--active' : ''}`}
              onClick={() => handleFilterChange(f.key)}
            >
              {f.label}
            </button>
          ))}
        </motion.div>

        <motion.div className="gallery__masonry" layout>
          <AnimatePresence mode="popLayout">
            {visibleItems.map((item, i) => (
              <motion.div
                key={item.id}
                className={`gallery__item gallery__item--${item.size}`}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                onClick={() => openLightbox(i)}
              >
                <div className="gallery__item-img-wrap">
                  <img
                    src={item.src}
                    alt={item.title}
                    loading="lazy"
                  />
                  <div className="gallery__item-overlay">
                    <div className="gallery__item-expand">
                      <FaExpand />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        {visibleCount < filtered.length && (
          <motion.div
            className="gallery__load-more"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ delay: 0.5 }}
          >
            <button
              className="gallery__load-btn"
              onClick={() => setVisibleCount((prev) => prev + 8)}
            >
              Load More Projects
            </button>
          </motion.div>
        )}

        <motion.div
          className="gallery__stats"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="gallery__stat">
            <span className="gallery__stat-number">2,000+</span>
            <span className="gallery__stat-label">Projects Completed</span>
          </div>
          <div className="gallery__stat-divider" />
          <div className="gallery__stat">
            <span className="gallery__stat-number">3,000+</span>
            <span className="gallery__stat-label">Happy Customers</span>
          </div>
          <div className="gallery__stat-divider" />
          <div className="gallery__stat">
            <span className="gallery__stat-number">30+</span>
            <span className="gallery__stat-label">Years of Experience</span>
          </div>
          <div className="gallery__stat-divider" />
          <div className="gallery__stat">
            <span className="gallery__stat-number">100%</span>
            <span className="gallery__stat-label">Client Satisfaction</span>
          </div>
        </motion.div>

        {/* Follow Us bar */}
        <motion.div
          className="gallery__follow"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <span className="gallery__follow-label">Follow Our Work</span>
          <div className="gallery__follow-links">
            <a
              href="https://www.facebook.com/profile.php?id=61573995033166"
              target="_blank"
              rel="noopener noreferrer"
              className="gallery__follow-btn gallery__follow-btn--fb"
            >
              <FaFacebookF />
              KAT99 Pvt Ltd
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61576524495471"
              target="_blank"
              rel="noopener noreferrer"
              className="gallery__follow-btn gallery__follow-btn--fb"
            >
              <FaFacebookF />
              Constructions by KAT99 | Galle
            </a>
            <a
              href="https://instagram.com/kat99_constructions"
              target="_blank"
              rel="noopener noreferrer"
              className="gallery__follow-btn gallery__follow-btn--ig"
            >
              <FaInstagram />
              @kat99_constructions
            </a>
          </div>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {lightbox.open && filtered[lightbox.index] && (
          <motion.div
            className="gallery__lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={closeLightbox}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {/* Close */}
            <button className="gallery__lightbox-close" onClick={closeLightbox}>
              <FaTimes />
            </button>

            {/* Counter top */}
            <div className="gallery__lightbox-counter-top">
              {lightbox.index + 1} / {filtered.length}
            </div>

            {/* Image */}
            <motion.div
              className="gallery__lightbox-content"
              key={lightbox.index}
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -40 }}
              transition={{ duration: 0.22 }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={filtered[lightbox.index].src}
                alt={filtered[lightbox.index].title}
              />
            </motion.div>

            {/* Bottom bar: arrows + counter only */}
            <div className="gallery__lightbox-bar" onClick={(e) => e.stopPropagation()}>
              <button
                className="gallery__lightbox-nav gallery__lightbox-nav--prev"
                onClick={() => navigateLightbox('prev')}
              >
                <FaChevronLeft />
              </button>
              <div className="gallery__lightbox-info" />
              <button
                className="gallery__lightbox-nav gallery__lightbox-nav--next"
                onClick={() => navigateLightbox('next')}
              >
                <FaChevronRight />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default ConstructionGallery;
